<template>
  <div>
    <Navbar />
    <div class="d-flex" id="wrapper">
      <div class="bg-light border-right" id="sidebar-wrapper">
        <Sidebar active="Master Data" />
      </div>
      <div id="page-content-wrapper">
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-3">
              <LeftMenu active="periksa-lab" />
            </div>
            <div class="col-md-9">
              <Alert
                v-if="deleteSuccess"
                :alert="{
                  title: 'Berhasil menghapus data',
                  type: 'success',
                  content: `Data periksa lab '${deleteItem.name}' telah berhasil dihapus dari sistem`,
                }"
              />
              <Alert
                v-if="deleteFailed"
                :alert="{
                  title: 'Gagal menghapus data',
                  type: 'danger',
                  content: `Terjadi kesalahan pada sistem. Data periksa lab '${deleteItem.name}' gagal dihapus dari sistem`,
                }"
              />
              <PageContentHeader
                :data="data"
                :fromUrl="fromUrl || ''"
                :fromTab="$route.query.fromTab || ''"
              />
              <!--div>
                  <div class="row mb-3">
                    <div class="col-md-12">
                      <b-tabs pills>
                        <b-tab v-for="item in tabs"
                          v-bind:key="item.title + String(Math.random(1023))" :title="item.title" @click="()=>filterTab(item.filter)"/>
                      </b-tabs>
                    </div>
                  </div>
                </!--div>-->

              <div class="card card-filter-sort no-print">
                <div class="row">
                  <div class="col-md-9">
                    <FormRow
                      :row="filters"
                      @handleChange="(e) => handleChange(e)"
                    />
                  </div>
                  <div class="col-md-3">
                    <FormRow
                      :row="sort"
                      @handleChange="(e) => handleChange(e)"
                    />
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <div class="row">
                  <div class="col-md-4">
                    <div class="row form-group mt-3">
                      <div class="col-md-12 d-flex flex-between">
                        <label class="mb-0 mr-3">Tampilkan</label>
                        <select class="form-control" v-model="perPage">
                          <option value="10">10 data</option>
                          <option v-if="rows.length > 10" value="25"
                            >25 data</option
                          >
                          <option v-if="rows.length > 25" value="50"
                            >50 data</option
                          >
                          <option v-if="rows.length > 50" value="100"
                            >100 data</option
                          >
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 offset-md-2">
                    <div class="form-group mt-3">
                      <input
                        type="text"
                        class="form-control with-icon-left without-label"
                        v-model="filter"
                        placeholder="Cari data di sini"
                        ref="focusMe"
                        @keydown="$event.stopImmediatePropagation()"
                      />
                      <i class="material-symbols-outlined">search</i>
                    </div>
                  </div>
                </div>
                <datatable
                  v-if="loaded && rows.length"
                  :columns="columns"
                  :per-page="parseInt(perPage)"
                  :data="rows"
                  :filter="filter"
                  class="table table-hover responsive"
                ></datatable>
                <EmptyState
                  v-else-if="loaded && !rows.length"
                  :data="{ size: 'small' }"
                />
                <Loading v-else />
                <br />
                <p v-if="rows.length">
                  Menampilkan
                  {{ rows.length > parseInt(perPage) ? perPage : rows.length }}
                  data dari total {{ rows.length }} data
                </p>
                <datatable-pager
                  v-if="loaded && rows.length"
                  v-model="page"
                  class="nav nav-tabs datatable-pager"
                  type="abbreviated"
                ></datatable-pager>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <button
      v-for="row in rows"
      v-bind:key="row.id + String(Math.random(1023))"
      :id="'delete' + row.id"
      @click="
        () => {
          deleteData(row.id, row.nama);
        }
      "
      style="display:none"
    ></button>
    <div class="modal modal-confirm" id="modalDelete" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <!--  <h5 class="modal-title">Modal title</h5>  -->
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            <!-- <h3 class="confirm-title">Delete Confirmation</h3> -->
            <img
              class="img-illustration delete-alert mb-0"
              src="/img/alert-triangle.svg"
              style="width:40%"
            />
            <p class="confirm-content mb-2">
              Apakah Anda yakin untuk menghapus data berikut?
            </p>
            <h4>{{ deleteItem.name }}</h4>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-danger"
              data-dismiss="modal"
            >
              TIDAK
            </button>
            <button
              id="btnDeleteItem"
              class="btn btn-danger"
              @click="
                () => {
                  confirmDelete(deleteItem.id);
                }
              "
              data-dismiss="modal"
            >
              YA
            </button>
          </div>
        </div>
      </div>
    </div>
    <button
      v-for="row in rows"
      v-bind:key="'discount' + row.id + Math.random(1024)"
      :id="'discount' + row.id"
      @click="
        () => {
          inputDiscount(
            row.id,
            `${row.kode} - ${row.nama}`,
            row.tipe_diskon,
            row.diskon,
            row.biaya_dewasa
          );
        }
      "
      style="display:none"
    ></button>
    <b-modal
      class="modal modal-confirm"
      id="modalDiscount"
      size="lg"
      no-close-on-esc
      no-close-on-backdrop
    >
      <template #modal-header>
        <div class="modal-title">
          <p class="mb-1">Input Diskon</p>
          <h5 class="mb-0 text-left text-primary">{{ discountItem.name }}</h5>
        </div>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
          @click="resetDiscount"
        >
          <span aria-hidden="true">×</span>
        </button>
      </template>
      <div class="container">
        <FormRow
          v-for="row in form"
          v-bind:key="row.colnum + String(Math.random(1023))"
          :row="row"
          @handleChange="(e) => discountChange(e)"
        />
      </div>
      <template #modal-footer>
        <div class="w-100">
          <button
            id="btndiscountItem"
            class="btn btn-primary float-right"
            @click="
              () => {
                saveDiscount(discountItem.id);
              }
            "
          >
            SIMPAN DISKON
          </button>
          <button
            type="button"
            class="btn btn-outline-primary mr-3 float-right"
            @click="resetDiscount"
          >
            BATAL
          </button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
// @ is an alias to /src

import Loading from "@/components/Loading.vue";
import EmptyState from "@/components/EmptyState.vue";
import Alert from "@/components/Alert.vue";
import Navbar from "@/components/Navbar.vue";
import Sidebar from "@/components/Sidebar.vue";
import LeftMenu from "@/components/LeftMenu.vue";
import PageContentHeader from "@/components/PageContentHeader.vue";
import FormRow from "@/components/FormRow.vue";
// import { HTTP } from "@/config.js";
import { dataPeriksaLab, tabs, sort, filters } from "@/data/Master.js";
//import jQuery from 'jquery';
import { convertToRupiah } from "@/data/helper.js";
const form = [
  {
    colnum: 2,
    class: "",
    columns: [
      {
        label: "Tipe Diskon",
        type: "select",
        placeholder: "Pilih Tipe Diskon",
        name: "tipe_diskon",
        value: "FIXED",
        options: [
          { value: "FIXED", label: "Jumlah Tetap" },
          { value: "PERCENTAGE", label: "Persentase" },
        ],
        mandatory: true,
        colwidth: "4",
      },
      {
        label: "Jumlah Diskon",
        type: "money",
        placeholder: "jumlah diskon",
        name: "diskon",
        value: 0,
        optional: true,
        colwidth: "4",
      },
    ],
  },
];
export default {
  name: "PeriksaLab",
  components: {
    Navbar,
    Sidebar,
    PageContentHeader,
    FormRow,
    Loading,
    LeftMenu,
    Alert,
    EmptyState,
  },
  data: () => {
    return {
      fromUrl: "",
      plainUrl: "",
      form: form,
      tipe_diskon: "FIXED",
      diskon: 0,
      discountSuccess: false,
      discountFailed: false,
      discountItem: { id: null, name: "", value: 0 },
      deleteItem: {
        id: "",
        name: "",
      },
      deleteSuccess: false,
      deleteFailed: false,
      loaded: false,
      data: dataPeriksaLab,
      filters: filters,
      sort: sort,
      tabs: tabs,
      created_at: "",
      orderBy: "desc",
      id_obat: "",
      pembayaran: ["Umum", "BPJS", "Optik Lain"],
      columns: [
        {
          label: "Id",
          field: "id",
          headerClass: "class-in-header second-class",
        },
        {
          label: "Kode",
          field: "kode",
          headerClass: "class-in-header second-class",
        },
        { label: "Periksa Lab", field: "nama" },
        { label: "Biaya Dewasa", field: "formatted_biaya_dewasa" },
        { label: "Biaya Anak", field: "formatted_biaya_anak" },
        {
          label: "Dt",
          representedAs: (row) => `${row.ditanggung == 1 ? "Ya" : "Tdk"}`,
        },
        {
          label: "Diskon",
          representedAs: (row) =>
            `${
              row.diskon
                ? row.tipe_diskon == "PERCENTAGE"
                  ? row.diskon + "%"
                  : convertToRupiah(row.diskon)
                : "-"
            }`,
        },
        {
          label: "Bagian Petugas",
          headerClass: "class-in-header second-class",
          representedAs: (row) =>
            `${row.petugas_persen ? row.petugas_persen : 0}%`,
        },
        {
          label: "",
          class: "dropdown",
          representedAs: (
            row
          ) => `<a class="btn btn-sm btn-success btn-icon" href="/#/master/periksa-lab/edit/${row.id}"><i class="material-symbols-outlined">create</i></a>
                <a class="btn btn-sm btn-icon btn-basic" data-toggle="dropdown" data-target="#" id="actionDropdown" aria-expanded="true">
                    <i class="material-symbols-outlined">apps</i>
                </a>
                <div class="dropdown-menu dropdown-menu-right dropdown-account" aria-labelledby="actionDropdown">
                    <a class="dropdown-item" href="/#/master/periksa-lab/edit/${row.id}" >
                        <i class="material-symbols-outlined">create</i>
                        Edit Data Periksa Lab
                    </a>
                     <a class="dropdown-item" data-toggle="modal" onclick="document.getElementById('discount${row.id}').click()" >
                        <i class="material-symbols-outlined">content_cut</i>
                        Input Diskon
                    </a>
                    <a class="dropdown-item" data-toggle="modal" data-target="#modalDelete" onclick="document.getElementById('delete${row.id}').click()">
                        <i class="material-symbols-outlined">delete</i>
                        Hapus Data Periksa Lab
                    </a>
                </div><div>`,
          interpolate: true,
        },
      ],
      filter: "",
      page: 1,
      countTotalRows: 0,
      perPage: 10,
      rows: [],
    };
  },
  methods: {
    discountChange(e) {
      this[e.target.name] = e.target.value;
      //console.log(e.target.name);
      //console.log(this[e.target.name]);
      //console.log(e.target.value);
      if (e.target.name == "tipe_diskon") {
        if (e.target.value == "FIXED") {
          this.form[0].columns[1].type = "money";
        } else {
          this.form[0].columns[1].type = "percentage";
        }
        this.form[0].columns[0].value = e.target.value;
        this.form[0].columns[1].value = 0;
      }
    },
    validateForm: function() {
      let valid = true;
      let self = this;
      this.form = this.form.map(function(row) {
        row.columns = row.columns.map(function(column) {
          if (
            !column.optional &&
            column.type != "hidden" &&
            !self[column.name]
          ) {
            //console.log(self[column.name]);
            valid = false;
            column.error = "Kolom ini wajib diisi";
          } else if (
            column.type == "percentage" &&
            (self[column.name] < 0 || self[column.name] > 100)
          ) {
            valid = false;
            column.error = "Nilai persentase harus di antara 0 s/d 100%";
          } else if (
            column.type == "money" &&
            (self[column.name] < 0 ||
              self[column.name] > parseInt(self.discountItem.value))
          ) {
            valid = false;
            column.error =
              "Nilai diskon harus di antara 0 s/d nilai harga obat";
          } else if (
            [
              "number",
              "money",
              "addon-right",
              "addon-left",
              "percentage",
            ].indexOf(column.type) > -1 &&
            !column.negativeValue &&
            parseInt(self.formSet[column.name]) < 0
          ) {
            column.error = "Nilai yang diisi tidak boleh negatif";
          } else {
            column.error = "";
          }
          if (self[column.name]) {
            column.value = self[column.name];
          }
          return column;
        });
        return row;
      });
      return valid;
    },
    inputDiscount: async function(id, name, tipe_diskon, diskon, value) {
      let self = this;
      this.discountItem = {
        id: id,
        name: name,
        value: value,
      };
      //console.log(this.discountItem);
      this.tipe_diskon = tipe_diskon || this.tipe_diskon;
      this.diskon = diskon;
      this.form = this.form.map(function(row) {
        row.columns = row.columns.map(function(column) {
          if (self[column.name]) {
            column.value = self[column.name];
          }
          return column;
        });
        return row;
      });
      if (this.tipe_diskon == "PERCENTAGE") {
        this.form[0].columns[1].type = "percentage";
      }
      this.$bvModal.show("modalDiscount");
    },
    async saveDiscount(id) {
      //console.log(id);
      let valid = this.validateForm();
      if (valid) {
        let params = `tipe_diskon=${this.tipe_diskon}&diskon=${
          this.diskon ? this.diskon : 0
        }`;
        //console.log(params);
        let result = await this.$store.state.HTTP.put(
          `periksalab/${id}`,
          params
        );
        //console.log(result);
        if (result.status == 200) {
          this.discountSuccess = true;
          await this.displayList();
          this.$nextTick(() => {
            if (this.$refs.focusMe) {
              this.$refs.focusMe.focus();
            }
          });
        } else {
          this.discountFailed = true;
        }
        this.resetAlert();
        this.resetDiscount();
      }
    },
    resetDiscount() {
      this.$bvModal.hide("modalDiscount");
      this.tipe_diskon = "FIXED";
      this.diskon = 0;
      this.form = form;
      this.discountItem = { id: null, name: "", value: 0 };
      this.form[0].columns[1].value = 0;
      this.form[0].columns[1].error = "";
      this.form[0].columns[1].type = "money";
    },
    deleteData(id, name) {
      this.deleteItem = {
        id: id,
        name: name,
      };
    },
    async confirmDelete(id) {
      //console.log(id);
      let result = await this.$store.state.HTTP.delete("periksalab/" + id);
      //console.log(result);
      if (result.status == 200) {
        this.deleteSuccess = true;
        await this.displayList();
        this.$nextTick(() => {
          if (this.$refs.focusMe) {
            this.$refs.focusMe.focus();
          }
        });
      } else {
        this.deleteFailed = true;
      }
      this.resetAlert();
    },
    resetAlert() {
      let self = this;
      setTimeout(function() {
        self.deleteSuccess = false;
        self.deleteFailed = false;
      }, 5000);
    },
    async filterTab(filter) {
      //console.log(filter);
      this["id_obat"] = filter;
      await this.displayList();
      this.$nextTick(() => {
        if (this.$refs.focusMe) {
          this.$refs.focusMe.focus();
        }
      });
    },
    async handleChange(e) {
      this[e.target.name] = e.target.value;
      //console.log(`${e.target.name}:${this[e.target.name]}`);
      await this.displayList();
      //this.$nextTick(()=>{if(this.$refs.focusMe){ this.$refs.focusMe.focus()}});
    },
    displayList: async function() {
      this.loaded = false;
      this.errors = [];
      let params = `?per_page=999999999999&orderBy=${this.orderBy}`;
      if (this["created_at"]) {
        params += `&created_at=${this.created_at}`;
      }
      if (this["id_obat"]) {
        params += `&id_obat=${this.id_obat}`;
      }
      try {
        let result = await this.$store.state.HTTP.get("periksalab" + params);
        //console.log(result);
        if (result.status == "200") {
          //console.log("berhasil");
          this.rows = result.data.data;
          this.loaded = true;
          //console.log(this.rows);
        } else {
          //console.log(result.status);
          this.errors.push(result.status);
          this.loaded = true;
        }
      } catch (e) {
        //console.log(e);
        this.errors.push(e);
        this.loaded = true;
      }
    },
  },
  beforeRouteEnter: function(to, from, next) {
    next((vm) => {
      vm.fromUrl = ["", "/"].indexOf(from.path) > -1 ? "" : from.fullPath;
      ////console.log(vm.fromUrl);
    });
  },
  mounted: async function() {
    await this.displayList();
    this.$nextTick(() => {
      if (this.$refs.focusMe) {
        this.$refs.focusMe.focus();
      }
    });
    //let $=jQuery;
    //bootstrap.load_file($);
  },
};
</script>
